import { styled } from '@styledComponents';
import { themeSpace } from '@utils/styledTheme.util';
import { Flex } from '@components/Flex';
import Chevron from './chevron.svg';
import { MediumBoldTextStyles } from '@components/typography/interVariants';

const inputFieldStyle = {
  backgroundColor: 'white',
  borderColor: '#D9D9D9',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: '8px',
  color: '#000000',
};

export const SelectWrapper = styled(Flex)`
  position: relative;
  margin-bottom: ${themeSpace(9)};
`;

export const StyledDropdown = styled.select`
  ${inputFieldStyle}
  width: 100%;
  ${MediumBoldTextStyles}
  padding: ${themeSpace(5)};
  appearance: none;
  cursor: pointer;
  background-image: url(${Chevron});
  background-repeat: no-repeat;
  background-position: calc(100% - 0.5rem) 50%;
`;
